import { LocationVarInheritance, LocationVarKey, MergedLocationVars, MergedVarsWithKeys } from '@swivl-mono/types';
import LocationVarsModel from '../Models/Variables/LocationVars.Model';
import { useMemo, useState } from 'react';
import { GetLocationVarFromVariables } from '@swivl-mono/helpers';
 type MergedVarsStrings<T extends LocationVarKey> = { [key in T]: string | undefined };

export function useLocationVariables<keys extends LocationVarKey>(keys: LocationVarKey[], groupId?: number, locationId?: number): MergedVarsStrings<keys> | undefined {
  const variables = useMergedLocationVariables(keys,groupId, locationId);

  if (!variables) {
    return undefined;
  }
  return Object.fromEntries(Object.entries(variables).map(([key, value]) => [key, value?.value]) as [keys, string | undefined][]) as MergedVarsStrings<keys>;
}


export function useMergedLocationVariables<keys extends LocationVarKey>(keys: LocationVarKey[],groupId?: number , locationId?: number): MergedVarsWithKeys<keys> | undefined {
  const { orgVariables, groupVariables, locationVariables, isLoaded } = LocationVarsModel.useState();
  // const [variables, setVariables] = useState<MergedVarsWithKeys<keys> | undefined>(undefined)


  const variables = useMemo(() => {
    if (!isLoaded) {
      return undefined;
    }
    if (!keys) {
      return {};
    }
    let output: MergedLocationVars = {};
    for (const key of keys) {
      if (key) {
        output[key] = GetLocationVarFromVariables(isLoaded, orgVariables, groupVariables, locationVariables, key, groupId, locationId);
      }
    }
    return output;
  }, [isLoaded, orgVariables, groupVariables, locationVariables, keys, groupId, locationId]);

  return variables as MergedVarsWithKeys<keys>;

}

